// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".480b3ef5711b14151688627bc8a2c930ee95dc31.chunk.js";
};